<!--
  TypingIndicator — the 3-dot "someone is typing…" bubble shown between bot messages.
  Purely presentational; `label` is the bubble's accessible name.
-->
<template>
  <div class="msg-row bot-row">
    <div class="av-placeholder" />
    <div class="typing-bubble" :aria-label="label">
      <span /><span /><span />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ label?: string }>(), { label: 'Rédaction en cours…' })
</script>

<style scoped>
.msg-row {
  display: flex;
  align-items: flex-end;
  padding: 0 16px;
  gap: 8px;
}
.av-placeholder {
  width: 32px;
  flex-shrink: 0;
}
.typing-bubble {
  background: var(--blue-100);
  border-radius: 16px;
  border-bottom-left-radius: 4px;
  padding: 10px 14px;
  display: flex;
  gap: 4px;
}
.typing-bubble span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--brand-default);
  animation: typingPulse 1.2s infinite ease-in-out;
}
.typing-bubble span:nth-child(2) {
  animation-delay: 0.15s;
}
.typing-bubble span:nth-child(3) {
  animation-delay: 0.3s;
}
@keyframes typingPulse {
  0%, 60%, 100% {
    opacity: 0.35;
    transform: scale(0.9);
  }
  30% {
    opacity: 1;
    transform: scale(1.1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .typing-bubble span {
    animation: none;
  }
}
</style>
